import React from "react";
import { useTranslation } from "react-i18next";
import DocList from "./DocList";

// Supplier -- matches Diamond-PO-Prototype-v3.html's sMemos() exactly (lines 897-899): every
// memo regardless of status, unlike SupplierRequests.js which only shows REQUESTED/PARTSHIP.
// Real gap found live-testing (22 Oct 2026): DocList.js was already written anticipating this
// screen ("backs three new pages: ... supplier counterparts ... not built", per its own header
// comment) but the page itself was never created -- a shipped memo (e.g. one that moved to
// DISCREPANCY) had no discovery path on the supplier side at all once it left "Requests".
export const SupplierMemosOut = () => {
  const { t } = useTranslation();
  return <DocList title={t("Memos Out")} description={t("Every memo, its shipments and returns")} kind="MEMO" whoColumn={t("Retailer")} whoField="RetailerName" />;
};

export default SupplierMemosOut;
